export default {
  'WELCOME:NAMECARD': '助理小蜜 进入会话为你服务',
  'WELCOME:MESSAGE': 'Hi，我是你的智能助理小蜜。想问什么尽管问，小蜜一直都在~',
  'WELCOME:BACK': '欢迎回来,继续你和小蜜的聊天吧..',
  'OSP:CONNECT:FAIL': '亲，当前服务繁忙，请稍后再试，或拨打官方热线 <a href="tel:0571-88158198">0571-88158198</a> 进行咨询',
  'OSP:SERVICE:JOIN': '人工小蜜 {{name}} 为您提供服务，愉快聊起来～',
  'OSP:SERVICE:LEAVE': '亲，等你好久没回来，人工小蜜已退出服务，您咨询的问题如果未解决，可以重新发起咨询~',
  'OSP:SERVICE:QUEUE': '人工小蜜正在赶来的路上，稍等哟~',
  'OSP:SERVICE:QUIT': '人工小蜜 已退出服务，很高兴遇见您~',
  'OSP:WELCOME:BACK': '欢迎回来，继续你和人工小蜜的聊天吧..',
  'OSP:WELCOME:CONTINUE': '亲，你刚刚的问题解决了嘛？如果没解决，小蜜可以为你连接刚刚为你服务的人工小蜜哦~',
  'OSP:QUEUE:BEGIN': '收到，小蜜马上变身人工小蜜，为您提供服务…',
  'OSP:QUEUE:COMING': '人工小蜜正在赶来的路上，稍等哟~',
  'OSP:USERLEAVE:LOGINELSE': '您已在其他地方登录',
  'OSP:SWITCH': '人工小蜜 转交了您的服务请求，正在为您连接…',
  'OSP:TIP:SOLVED': '好勒，能为你解决问题是小蜜今天最开心的事啦！小蜜还能为你提供更多服务哦，订机票、充话费、查天气等都可以随时跟我说~',
  'ROBOT:EXCEPTION': 'Uh oh! Something went wrong at our side. Don\'t worry, it\'s not you. Sorry about that.',
  'ROBOT:UNKNOWN': '亲，小蜜瞬间断片了，亲请重新描述您的问题，或提交订单给我，小蜜立马帮你去处理~',
  'ROBOT:NOANSWER': 'Sorry,I can`t understand, you can ask in a different way',
  'ROBOT:TO:OCS': '亲，你遇到什么问题啦？描述你的问题，小蜜帮你找人工~',
  'ROBOT:TO:OCSBUSY': '亲亲，很抱歉，双11活动咨询太火爆了，人工小蜜正在努力赶来的路上，请稍等，你可以先伸个懒腰休息下~',
  'ROBOT:OCS:ENTRY': '小蜜没解决您的问题？<a href="javascript:;" class="J_GoManual">找人工阿里小蜜<i class="iconfont icon-arrow-right"></i></a>',
  'FIRSTMESSAGE:EXCEPTION': '哎呀，小蜜没有找到你可能想了解的内容，亲可以直接向我提问哟，比如【如何申请退款】~',
  'FIRSTMESSAGE:TIP': '<p>小蜜在，亲需要我做什么吗？</p><p>购物问题、订机票、查天气等都可以问我哦～ </p>',
  'FIRSTMESSAGE:ROBOT:ENTRY': '没有我想要的，<a href="javascript:;" class="J_Action">找小蜜聊聊</a>',
  'FIRSTMESSAGE:SHOW': '有问题？<a href="javascript:;" class="J_Action">找我的小蜜</a>',
  'KNOWLEDGE:RATE:GOOD': 'oyeah！谢谢你给小蜜一个大大的赞，么么哒~',
  'KNOWLEDGE:RATE:BAD': '呜呜~小蜜会继续学习，下次为你提供更好的服务~',
  'KNOWLEDGE:RATE:ASK': '呜呜~小蜜回答的不好吗？描述你觉得不好的原因，小蜜会根据你的描述，找合适的人工小蜜为你服务~',
  'KNOWLEDGE:RATE:FEEDBACK': '已收到你的反馈！小蜜要回去好好学习了，你可以召唤人工小蜜~',
  'KNOWLEDGE:CHANGEORDERTIP': '沟通过程中，若需咨询不同订单遇到的问题，请先点击输入区<a href="javascript:;" class="J_HookSelectOrder">‘+’选择订单</a>发给小蜜哦',
  'HISTORY:LOADFAIL': '历史消息加载失败，请稍后再试',
  'HISTORY:NOMORE': '哎呀，消息都被你看完啦，羞涩⁄(•⁄ω⁄•)⁄',
  'CARD:ENTRY': '【人工小蜜】',
  'APP:NAME': '小蜜',
  'SHORTCUT:DISPATCH': '召唤人工小蜜',
};



// WEBPACK FOOTER //
// ./src/app/lang.js